import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { configureAppStore } from './redux';
import localeConfig from 'config/localeConfig';
import Root from 'components/Root';
import CatchAllErrors from 'components/CatchAllError';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@icims-design-system/mui-core';
import { createTheme } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import icimsI18next from '@icims-design-system/i18next';
import { CircularProgress } from '@mui/material';

import theme from '@icims-design-system/mui-theme';
import { teMuiTheme } from 'te-components';
import { customTheme } from './theme';
import { updateMomentLocale } from 'util/updateMomentLocale';

// TODO: this should no longer be needed. -Amir
// import '@icimscorp/mui/build/font.css';

// Update moment's locale when the project initially loads.

export const store = configureAppStore();

const lightTheme = createTheme({ ...customTheme, ...theme, ...teMuiTheme });

export default function App() {
  const { languageSetToNearestMatch, languageSetTo, languageCode } = updateMomentLocale(
    localStorage['icims.config.locale'],
  ) || { languageSetToNearestMatch: false, languageSetTo: '', languageCode: 'en-US' };

  const [isLanguageSetToClosestMatch, setLanguageSetToClosestMatch] =
    React.useState(languageSetToNearestMatch);

  return (
    <>
      <I18nextProvider i18n={icimsI18next(localeConfig)}>
        {/* @ts-expect-error the type hint by icims-theme-provider does not extend from mui-theme object  */}
        <ThemeProvider themes={{ light: lightTheme }}>
          <React.Suspense fallback={<CircularProgress />}>
            {/* @ts-expect-error: ReduxProvider type mismatch */}
            <ReduxProvider store={store}>
              {/* @ts-expect-error: HashRouter type mismatch */}
              <HashRouter basename="/">
                {/* @ts-expect-error: CatchAllErrors type mismatch */}
                <CatchAllErrors>
                  <Root
                    handleClose={setLanguageSetToClosestMatch}
                    languageSetTo={languageSetTo}
                    isLanguageSetToClosestMatch={isLanguageSetToClosestMatch}
                    languageCode={languageCode}
                  />
                </CatchAllErrors>
              </HashRouter>
            </ReduxProvider>
          </React.Suspense>
        </ThemeProvider>
      </I18nextProvider>
    </>
  );
}
